"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactStyleProptype = _interopRequireDefault(require("react-style-proptype"));

var _Radio = _interopRequireWildcard(require("./Radio"));

var _this = void 0;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var RadioGroup = function RadioGroup(props) {
  var initialSelected = '';
  var valueSelected = props.valueSelected,
      defaultSelected = props.defaultSelected,
      style = props.style,
      className = props.className,
      inline = props.inline,
      onChange = props.onChange;

  if (valueSelected !== undefined) {
    initialSelected = valueSelected;
  } else if (defaultSelected !== undefined) {
    initialSelected = defaultSelected;
  }

  var _useState = (0, _react.useState)(initialSelected),
      _useState2 = _slicedToArray(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  var handleChange = (0, _react.useCallback)(function (event, selectedItem) {
    setSelected(selectedItem);
    if (onChange) onChange(event, selectedItem);
  }, [onChange]);
  var composedStyle = inline ? _objectSpread({}, style, {
    display: 'flex',
    alignItems: 'baseline',
    flexWrap: 'wrap'
  }) : _objectSpread({}, style);

  var options = _react["default"].Children.map(props.children, function (option) {
    var _option$props = option.props,
        name = _option$props.name,
        value = _option$props.value,
        label = _option$props.label,
        onCheck = _option$props.onCheck,
        other = _objectWithoutProperties(_option$props, ["name", "value", "label", "onCheck"]);

    return option.type && option.type.displayName === _Radio.RADIO_NAME ? _react["default"].createElement(_Radio["default"], _extends({}, other, {
      name: props.name,
      key: option.props.value,
      value: option.props.value,
      label: option.props.label,
      onCheck: handleChange,
      checked: option.props.value === selected,
      style: _objectSpread({
        marginRight: '20px'
      }, option.props.style)
    })) : option;
  }, _this);

  return _react["default"].createElement("div", {
    style: composedStyle,
    className: className
  }, options);
};

var _default = RadioGroup;
exports["default"] = _default;
RadioGroup.propTypes = {
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  defaultSelected: _propTypes["default"].any,
  // eslint-disable-line react/forbid-prop-types
  name: _propTypes["default"].string.isRequired,
  onChange: _propTypes["default"].func,
  style: _reactStyleProptype["default"],
  inline: _propTypes["default"].bool,
  valueSelected: _propTypes["default"].any // eslint-disable-line react/forbid-prop-types

};
RadioGroup.defaultProps = {
  className: '',
  inline: false
};